export const URL = {
    STATIC: {},
    GENERIC: {
        PATCH_SLIDE_IMAGE: (value) => `/apps/catalog/catalogImage.mvc?type=highschool&variant=option_md&option=${value}&imageType=option&customerNumber&jc3b=20211117242&version=2&bypassCache=true`
    }
}